import request from 'superagent';
import tree from '../state';
import config from '../config';

/* eslint-disable */

export function getProduct(sku) {
	return request.get(`${config.apiBase}/api/product/${sku}`)
		.set('authorization', tree.get('token'))
		.then(res => JSON.parse(res.text));
}

export function productSearch(data) {
	return request.get(`${config.apiBase}/api/productsearch`)
		.set('authorization', tree.get('token'))
		.query(data)
		.then(res => JSON.parse(res.text));
}

export function getProductsToCompare(skus) {
	return request.get(`${config.apiBase}/api/product/compare`)
		.set('authorization', tree.get('token'))
		.query(skus)
		.then(res => JSON.parse(res.text));
}

export function getProductsSearch(skus) {
	return request.get(`${config.apiBase}/api/product/search?skuNumber=${skus}`)
		.set('authorization', tree.get('token'))
		.then(res => JSON.parse(res.text));
}


// WEBPACK FOOTER //
// ./src/services/productService.js